import { Capacitor } from "@capacitor/core";
import { getLocal, setLocal, getSession, setSession, removeSession } from "./storageUtils";

export const SESSION_KEY = "sa_lax_session";

// On native the WKWebView process can be killed in the background, wiping
// sessionStorage. Use localStorage on native so sessions survive restarts.
const native = Capacitor.isNativePlatform();

function loadSession() {
  return native ? getLocal(SESSION_KEY, null) : getSession(SESSION_KEY, null);
}
function saveSession(session) {
  if (native) setLocal(SESSION_KEY, session);
  else setSession(SESSION_KEY, session);
}
function clearSession() {
  try {
    if (native) localStorage.removeItem(SESSION_KEY);
    else sessionStorage.removeItem(SESSION_KEY);
  } catch {}
}

export { loadSession, saveSession, clearSession };
